export default __webpack_public_path__ + "static/media/404.8bd8e605.svg";